import styled from "@emotion/styled";
import tw from "twin.macro";

export const Table = styled("table")(tw`h-px`);

export const TableHead = styled("thead")();

export const TableRow = styled("tr")();

export const TableHeading = styled("th")(
  tw`py-4 px-6 text-sm font-medium text-gray-900 text-left whitespace-nowrap`,
);
TableHeading.defaultProps = {
  scope: "col",
};

export const HighlightedTableHeading = styled(TableHeading)(
  tw`bg-gray-600 text-white font-semibold`,
);
HighlightedTableHeading.defaultProps = {
  scope: "col",
};

export const TableBody = styled("tbody")(tw`border-t border-gray-200 divide-y divide-gray-200`);

export const TableSubheading = styled("th")(
  tw`bg-gray-50 py-3 pl-6 text-sm font-medium text-gray-900 text-left whitespace-nowrap`,
);
TableSubheading.defaultProps = {
  scope: "colgroup",
};

export const HighlightedTableSubheading = styled("th")(
  tw`bg-gray-700 text-white font-semibold border-gray-700 border-t`,
);
HighlightedTableSubheading.defaultProps = {
  scope: "colgroup",
};

export const TableRowLabel = styled("th")(
  tw`py-3 px-6 text-sm font-normal text-gray-500 text-left whitespace-nowrap`,
);
TableRowLabel.defaultProps = {
  scope: "row",
};

export const TableCell = styled("td")(tw`py-3 px-6 text-sm text-gray-600 whitespace-nowrap`);

export const NarrowTableCell = styled(TableCell)(tw`py-1`);

export const HighlightedTableCell = styled(TableCell)(
  tw`bg-gray-600 text-white font-semibold border-gray-700 border-t`,
);
